import autoBind from 'react-autobind';
import {connect} from 'react-redux';
import {keyCodes} from '../../shared/constants';
import {Map} from 'immutable';
import {withRouter} from 'react-router';
import {DocumentDownloader, Filter, FilterChips} from '../../shared/components';
import {
  getCurrentUserHasProjectTeamologySchool
} from '../../authentication/selectors';
import {
  getAllMaterials,
  getLibraryFilters,
  resetDownloadUrl,
  setDownloadUrl,
  updateLibraryFilters,
  updateLibrarySearchString,
  updateMaterialsBySearchString,
} from '../actions';
import {LibraryMaterialList, LibrarySearch} from './index';
import {
  MainContent,
  Page,
  PageBody,
  PageHeader,
  SideNavigationBar
} from '../../layout/components';
import React, {Component, PropTypes} from 'react';

class LibraryPage extends Component {
  constructor(props, context) {
    super(props, context);
    autoBind(this);
  }

  componentDidMount() {
    const {getLibraryFilters, getAllMaterials} = this.props;
    getLibraryFilters();
    getAllMaterials();
  }

  handleSearchRequest(searchString) {
    this.props.updateMaterialsBySearchString(searchString);
  }

  handleUpdateSearchString(searchString) {
    this.props.updateLibrarySearchString(searchString);
  }

  // AutoComplete doesn't fire an update when Enter is pressed if the
  //  search field is empty. We want to clear search filters when this happens
  handleSearchBarKeyPress(event) {
    const {searchString} = this.props;

    if (event.charCode === keyCodes.ENTER && !searchString) {
      this.props.updateMaterialsBySearchString('');
    }
  }

  handleDownloadDocument(materialId) {
    this.props.setDownloadUrl(materialId);
  }

  handleDocumentDownloaded() {
    this.props.resetDownloadUrl();
  }

  getMatchingMaterialsMessage(filteredMaterials) {
    if (filteredMaterials && filteredMaterials.length) return null;
    return <div className="no-matching-materials-message">No Matching Materials</div>;
  }

  render() {
    const {
      loading,
      materials,
      filteredMaterials,
      downloadUrl,
      updateLibraryFilters,
      filters,
      searchString,
      userHasProjectTeamologySchool
    } = this.props;

    let mainContent = null;
    if (userHasProjectTeamologySchool) {
      mainContent =
      <div>
        <LibrarySearch
            onSearchRequest={this.handleSearchRequest}
            onInputUpdate={this.handleUpdateSearchString}
            onKeyPressUpdate={this.handleSearchBarKeyPress}
            materialTitles={materials.map(m => m.title)}
            searchString={searchString} />
        <div className="library-material-filter-container">
          <FilterChips filters={filters.toJS()} onFilterRemove={updateLibraryFilters} />
          <Filter filters={filters.toJS()} onFilterRequest={updateLibraryFilters} />
        </div>
        <LibraryMaterialList materials={filteredMaterials} onDocumentDownload={this.handleDownloadDocument} />
        { this.getMatchingMaterialsMessage(filteredMaterials) }
      </div>
    } else {  
      mainContent = <div className="not-authorized">The Library is for schoolwide access only.  Contact TEAMology to learn more.</div>
    }

    return (
      <Page pageClassName="library-page">
        <PageHeader title="Library" />
        <PageBody>
          <SideNavigationBar />
          <MainContent loading={loading} >
          {mainContent}
          </MainContent>          
        </PageBody>
        <DocumentDownloader downloadUrl={downloadUrl} onDocumentDownloaded={this.handleDocumentDownloaded} />
      </Page>
    );
  }
}

function mapStateToProps(state) {
  const {libraryPage} = state.features.library;

  return {
    materials: libraryPage.get('materials'),
    filteredMaterials: libraryPage.get('filteredMaterials'),
    loading: libraryPage.get('loading'),
    downloadUrl: libraryPage.get('downloadUrl'),
    searchString: libraryPage.get('searchString'),
    filters: libraryPage.get('filters'),
    userHasProjectTeamologySchool: getCurrentUserHasProjectTeamologySchool(state),
  };
}

LibraryPage.propTypes = {
  downloadUrl: PropTypes.string.isRequired,
  filteredMaterials: PropTypes.array.isRequired,
  filters: PropTypes.instanceOf(Map).isRequired,
  getAllMaterials: PropTypes.func.isRequired,
  getLibraryFilters: PropTypes.func.isRequired,
  userHasProjectTeamologySchool: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  materials: PropTypes.array.isRequired,
  resetDownloadUrl: PropTypes.func.isRequired,
  searchString: PropTypes.string.isRequired,
  setDownloadUrl: PropTypes.func.isRequired,
  updateLibraryFilters: PropTypes.func.isRequired,
  updateLibrarySearchString: PropTypes.func.isRequired,
  updateMaterialsBySearchString: PropTypes.string.isRequired,
};

export default withRouter(connect(
  mapStateToProps,
  {
    getAllMaterials,
    setDownloadUrl,
    resetDownloadUrl,
    updateMaterialsBySearchString,
    updateLibrarySearchString,
    updateLibraryFilters,
    getLibraryFilters
  })(LibraryPage));



// WEBPACK FOOTER //
// ./app/features/library/components/LibraryPage.js